import { inject, Injectable } from '@angular/core'
import { Translation, TranslocoLoader } from '@jsverse/transloco'
import { HttpClient } from '@angular/common/http'

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient)

  /**
   * @param path - For root: lang only (e.g. 'en-GB'). For scopes: 'scope/lang' (e.g. 'log/en-GB').
   * Transloco already encodes scope in path; do not prepend scope again.
   */
  getTranslation(path: string) {
    return this.http.get<Translation>(`/assets/i18n/${path}.json`)
  }
}
